<template>
  <div class="ticket-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd"
              :value="datePic"
              @on-change="changeSearchDate"
              style="width: 200px"
              placeholder="开始时间 - 结束时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :xs="24" :sm="12">
        <Button @click="showModel()" type="success" class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createOrUpdate('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="开始日期" prop="date_at">
          <DatePicker
            type="date"
            placeholder="请选择开始日期"
            v-model="dataInfo.date_at"
            @on-change="changeDate"
            style="width: 200px"
          ></DatePicker>
        </FormItem>
        <FormItem label="开场时间" prop="beigin_at">
          <TimePicker
            v-model="dataInfo.beigin_at"
            format="HH:mm"
            placeholder="开场时间"
            style="width: 200px"
            @on-change="changeDateOne"
          ></TimePicker>
        </FormItem>
        <FormItem label="结束时间" prop="end_at">
          <TimePicker
            v-model="dataInfo.end_at"
            format="HH:mm"
            placeholder="结束时间"
            style="width: 200px"
            @on-change="changeDateTwo"
          ></TimePicker>
        </FormItem>
        <FormItem label="库存">
          <Input v-model="dataInfo.store" placeholder="库存"></Input>
        </FormItem>
        <FormItem label="团队可约数量">
          <Input v-model="dataInfo.store_team_num" placeholder="团队可约数量"></Input>
        </FormItem>
        <FormItem label="团队票单价">
          <Input v-model="dataInfo.team_ticket_price" placeholder="团队票单价"></Input>
        </FormItem>
        <!-- <FormItem label="是否通票" label-position="top">
          <RadioGroup v-model="dataInfo.is_through_ticket">
            <Radio label="0">否</Radio>
            <Radio label="1">是</Radio>
          </RadioGroup>
        </FormItem>-->
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ticket-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      title: "",
      dayList: [], // 生成当前天开始往后的30天；
      datePic: [],
      timeatList: [], // 场次
      params: {
        datetime: []
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "开场时间",
          width: 180,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.date_at + " " + params.row.beigin_at)
            ]);
          }
        },
        {
          title: "结束时间",
          width: 180,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.date_at + " " + params.row.end_at)
            ]);
          }
        },
        {
          title: "销量",
          width: 180,
          key: "sales"
        },
        {
          title: "库存",
          width: 180,
          key: "store"
        },
        {
          title: "团队已预约数量",
          width: 180,
          key: "sale_team_num"
        },
        {
          title: "团队可预约数量",
          width: 180,
          key: "store_team_num"
        },

        {
          title: "团体票单价",
          width: 180,
          key: "team_ticket_price"
        },
        {
          title: "状态",
          width: 180,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 1 ? "上架" : "下架")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          width: 250,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.ticketprice(params.row.id);
                    }
                  }
                },
                "票价"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      params.row.status == 1
                        ? this.editStatus(params.row.id, 0)
                        : this.editStatus(params.row.id, 1);
                    }
                  }
                },
                params.row.status == "1" ? "下架" : "上架"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        begin_at: "",
        end_at: "",
        date_at: "",
        store: "0",
        team_plan_num: "0",
        team_ticket_price: "0"
      },
      showModalStatus: false,
      dataInfoValidate: {},
      venue_id: 0
    };
  },
  // 组件
  components: {},
  created: function() {
    this.venue_id = this.$route.params.id;
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.smartticket
        .list({
          page: this.pages.page,
          size: this.pages.size,
          venue_id: this.venue_id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        begin_at: "",
        end_at: "",
        date_at: "",
        store: "0",
        team_plan_num: "0",
        team_ticket_price: "0"
      };
      this.showModalStatus = !this.showModalStatus;
    },
    ticketprice(id) {
      this.$router.push("/smartticketprice/list/" + id);
    },
    changeDate(val) {
      this.dataInfo.date_at = val;
    },
    changeDateTwo(val) {
      this.dataInfo.end_at = val;
    },
    changeDateOne(val) {
      this.dataInfo.begin_at = val;
    },
    changeSearchDate(val) {
      this.params.datetime = val;
    },
    // 添加
    createOrUpdate(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.dataInfo.venue_id = this.venue_id;
          if(this.dataInfo.begin_at > this.dataInfo.end_at){
            this.$Message.error("结束时间不能早于开始时间，请重新选择！");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          if (
            this.dataInfo.id == 0 ||
            this.dataInfo.id == null ||
            this.dataInfo.id == undefined
          ) {
            this.dataInfo.is_through_ticket = 0;
            this.$api.smartticket.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.showModalStatus = !this.showModalStatus;
              } else {
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
              }
            });
          } else {
            this.$api.smartticket.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.showModalStatus = !this.showModalStatus;
              } else {
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
              }
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smartticket.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var bgn_date =
        this.params.datetime[0] != undefined ? this.params.datetime[0] : "";
      var end_date =
        this.params.datetime[1] != undefined ? this.params.datetime[1] : "";
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        venue_id: this.venue_id,
        starttime: bgn_date,
        endtime: end_date
      };
      this.$api.smartticket.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 上下架
    editStatus: function(id, index) {
      this.$api.smartticket.status({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
